import React from 'react';
import BeneficiaryAddressInput from './BeneficiaryAddressInput';

export default class SpouseBeneficiaryAddressInput extends BeneficiaryAddressInput {
  static forSpouse = true;
}
